module.exports = __webpack_public_path__ + "img/general.00ce82d6.png";